import { create } from 'zustand'
import type { PackResultCard } from '../engine/PackSystem.js'

export type ShopTab = 'packs' | 'gems' | 'season'

// Re-export PackResultCard from the engine so consumers can import from here
export type { PackResultCard }

interface ShopState {
  isOpen: boolean
  activeTab: ShopTab
  lastPackResult: PackResultCard[] | null
  showPackAnimation: boolean

  // actions
  openShop: (tab?: ShopTab) => void
  closeShop: () => void
  setTab: (tab: ShopTab) => void
  setPackResult: (cards: PackResultCard[]) => void
  closePackAnimation: () => void
}

export const useShopStore = create<ShopState>()((set) => ({
  isOpen: false,
  activeTab: 'packs',
  lastPackResult: null,
  showPackAnimation: false,

  openShop: (tab = 'packs') =>
    set({ isOpen: true, activeTab: tab }),

  closeShop: () =>
    set({ isOpen: false }),

  setTab: (tab) =>
    set({ activeTab: tab }),

  setPackResult: (cards) =>
    set({ lastPackResult: cards, showPackAnimation: true }),

  closePackAnimation: () =>
    set({ showPackAnimation: false, lastPackResult: null }),
}))
